"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _reactDeviceDetect = require("react-device-detect");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ramda = require("ramda");
var _Button = _interopRequireWildcard(require("../Button"));
var _handlers = require("../../../helpers/handlers");
var _withContext = require("./withContext");
var _back = _interopRequireDefault(require("./back.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var renderBody = function renderBody(jsx) {
  return _reactDeviceDetect.isMobileOnly ? (0, _reactDom.createPortal)(jsx, global.document.querySelector('body')) : jsx;
};
var DropdownBody = exports.DropdownBody = function DropdownBody(_ref) {
  var className = _ref.className,
    mobileHeaderClassName = _ref.mobileHeaderClassName,
    children = _ref.children,
    mobileHeaderContent = _ref.mobileHeaderContent,
    title = _ref.title,
    _ref$onBack = _ref.onBack,
    onBack = _ref$onBack === void 0 ? _ramda.F : _ref$onBack;
  var _useDropdownContext = (0, _withContext.useDropdownContext)(),
    close = _useDropdownContext.close;
  return renderBody(/*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.dropdownBody, className)
  }, _reactDeviceDetect.isMobileOnly && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.mobileHeader, mobileHeaderClassName)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.back,
    icon: _back.default,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: (0, _handlers.handleWith)(close, onBack)
  }), title, mobileHeaderContent), children));
};
DropdownBody.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  mobileHeaderContent: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element]),
  mobileHeaderClassName: _propTypes.default.string,
  title: _propTypes.default.node,
  onBack: _propTypes.default.func
};